import React from 'react';
import {avatarSizesAndCoefficients} from '../../utils/constants/avatar-sizes-and-coefficients';
import {SvgIconComponent, KeyboardArrowDown} from '@mui/icons-material';
import {Avatar, Box, Button, Typography, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import {Pallete} from '../../theme/bluebird';

const ButtonInfo = (props: {
  info: {
    title: string;
    picture: string;
    defaultIconName: SvgIconComponent;
  };
  active?: boolean;
  showTitle?: boolean;
}) => {
  const avatarWidth: string = `28px`;
  const avatarHeight: string = `28px`;
  const avatarIconSize: string = `${
    avatarSizesAndCoefficients.avatarSizes.medium * avatarSizesAndCoefficients.iconSizeCoefficient
  }px`;

  return (
    <>
      <Avatar
        sx={{
          width: avatarWidth,
          height: avatarHeight,
          backgroundColor: 'transparent',
          color: Pallete.gray.base,
        }}
        alt={props.info.title}
        src={props.info.picture}
      >
        <SvgIcon
          component={props.info.defaultIconName}
          sx={{
            fontSize: avatarIconSize,
            color: props.active ? Pallete.blue.base : Pallete.gray.base,
          }}
        />
      </Avatar>
      {props.showTitle ?? (
        <Box
          sx={{
            display: {xs: 'none', sm: 'flex'},
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: '8px',
            textTransform: 'none',
          }}
        >
          <Typography
            variant="body1"
            textAlign="left"
            lineHeight="initial"
            sx={{
              textOverflow: 'ellipsis',
              maxWidth: '250px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {props.info.title}
          </Typography>
        </Box>
      )}
    </>
  );
};

export const RoleDropdown = (props: {
  info: {
    title: string;
    picture: string;
    defaultIconName: SvgIconComponent;
  };
  active?: boolean;
  showTitle?: boolean;
  handleClick?: (event: React.MouseEvent<HTMLElement>) => void;
  handleClose?: () => void;
  children?: JSX.Element;
}) => {
  const theme = useTheme();

  const color = props.active ? Pallete.blue.base : theme.palette.text.primary;
  const backgroundColor = props.active ? Pallete.blue.lighter : theme.palette.background.paper;
  const border = props.active
    ? `1px solid ${Pallete.blue.base}`
    : `1px solid ${Pallete.blue.lighter}`;

  return (
    <>
      <Button
        id="user-menu-button"
        color="inherit"
        disableElevation
        onClick={props.handleClick}
        endIcon={props.handleClick ? <KeyboardArrowDown /> : null}
        sx={{
          paddingLeft: {xs: '8px', sm: '16px'},
          paddingRight: {xs: '8px', sm: '16px'},
          backgroundColor: backgroundColor,
          color: color,
          height: '40px',
          border: border,
          '&:hover': {backgroundColor: Pallete.blue.lighter},
        }}
        disableRipple={!props.handleClick}
      >
        <ButtonInfo info={props.info} active={props.active} showTitle={props.showTitle} />
      </Button>
    </>
  );
};
